import * as tslib_1 from "tslib";
import { EventEmitter } from '@angular/core';
import { map } from 'rxjs/operators';
import { AuthConfig } from './auth-config';
import { AUTH_CONFIG } from '../../../config/api';
import * as i0 from "@angular/core";
import * as i1 from "./auth-config";
import * as i2 from "@angular/common/http";
import * as i3 from "../../../service/navigation.service";
import * as i4 from "../../../service/main-tabs.service";
import * as i5 from "../../../service/loader.service";
import * as i6 from "../../../shared/popup/popup.component";
var AuthenticationService = /** @class */ (function () {
    function AuthenticationService(authConfig, http, navigationService, mainTabsService, loaderService, popupComponent) {
        this.authConfig = authConfig;
        this.http = http;
        this.navigationService = navigationService;
        this.mainTabsService = mainTabsService;
        this.loaderService = loaderService;
        this.popupComponent = popupComponent;
        this.btnLoginText = {
            login: "Login",
            logout: "Logout",
            help: "Help",
            account: "Account"
        };
        this.activeLoginBtnText = "";
        this.config = AUTH_CONFIG;
        // private storage = sessionStorage;
        this.storage = localStorage;
        this.rolesObservable = new EventEmitter();
        this.userLoggedIn = new EventEmitter();
        this.resetLoginBtnText();
    }
    AuthenticationService.prototype.isUserLogged = function () {
        return !!this.storage.getItem('currentUser');
    };
    AuthenticationService.prototype.helpLoginBtnText = function () {
        this.activeLoginBtnText = this.btnLoginText.help;
    };
    AuthenticationService.prototype.accountLoginBtnText = function () {
        this.activeLoginBtnText = this.btnLoginText.account;
    };
    AuthenticationService.prototype.resetLoginBtnText = function () {
        this.activeLoginBtnText = this.isUserLogged() ? this.btnLoginText.logout : this.btnLoginText.login;
    };
    AuthenticationService.prototype.checkPhoneAndSendPin = function (phone, authHash) {
        this.loaderService.show();
        var body = {};
        if (phone) {
            body.phone = phone;
        }
        if (authHash) {
            body.authHash = authHash;
        }
        //console.log('checkPhoneAndSendPin', body);
        // if (environment.frontEndTest) {
        //     body.country = 'us';
        // }
        return this.http.post(this.config.checkPhoneAndSendPin, body);
    };
    AuthenticationService.prototype.register = function (firstName, lastName, promoCode, password, phone, pin) {
        var _this = this;
        this.loaderService.show();
        //console.log('register', firstName, lastName, promoCode, password, phone, pin);
        return this.http.post(this.config.register, { first_name: firstName, last_name: lastName, promo_code: promoCode, password: password, phone: phone, pin: pin })
            .pipe(map(function (res) {
            if (res.status) {
                _this.setUserLogged(res.result, phone);
                if (res.authHash) {
                    localStorage.setItem('authHash', res.authHash);
                }
            }
            return res;
        }));
    };
    AuthenticationService.prototype.addByPhone = function (phone, firstName, lastName, password, pin) {
        var _this = this;
        this.loaderService.show();
        // console.log('addByPhone', firstName, lastName, password, phone, pin);
        return this.http.post(this.config.addByPhone, { phone: phone, firstName: firstName, lastName: lastName, password: password, pin: pin })
            .pipe(map(function (res) {
            if (res.status) {
                _this.setUserLogged(res.result, phone);
                if (res.authHash) {
                    localStorage.setItem('authHash', res.authHash);
                }
            }
            return res;
        }));
    };
    AuthenticationService.prototype.login = function (phone, pin, password, code, authHash) {
        var _this = this;
        this.loaderService.show();
        var body = {
            code: code
        };
        if (phone) {
            body.phone = phone;
        }
        if (password) {
            body.password = password;
        }
        if (pin) {
            body.pin = pin;
        }
        if (authHash) {
            body.authHash = authHash;
        }
        //console.log('login', body);
        // if (environment.frontEndTest) {
        //     body = {
        //         phone: phone,
        //         pin: pin,
        //         country: 'us'
        //     }
        // }
        return this.http.post(this.config.login, body)
            .pipe(map(function (res) {
            //console.log(res)
            if (res.status) {
                _this.setUserLogged(res.result, phone);
                if (res.authHash) {
                    localStorage.setItem('authHash', res.authHash);
                }
            }
            return res;
        }));
    };
    AuthenticationService.prototype.loginAfterReset = function (phone, code, password) {
        var _this = this;
        this.loaderService.show();
        var body = {};
        if (phone) {
            body.phone = phone;
        }
        if (code) {
            body.pin = code;
        }
        if (password) {
            body.password = password;
        }
        //console.log('loginAfterReset', body);
        // if (environment.frontEndTest) {
        //     body = {
        //         phone: phone,
        //         pin: code,
        //         country: 'us'
        //     }
        // }
        return this.http.post(this.config.loginAfterReset, body)
            .pipe(map(function (res) {
            //console.log(res)
            if (res.status) {
                _this.setUserLogged(res.result, phone);
                if (res.authHash) {
                    localStorage.setItem('authHash', res.authHash);
                }
            }
            return res;
        }));
    };
    AuthenticationService.prototype.loginSendResetCode = function (phone, pin) {
        this.loaderService.show();
        var body = {};
        if (phone) {
            body.phone = phone;
        }
        if (pin) {
            body.pin = pin;
        }
        //console.log('loginSendResetCode', body)
        return this.http.post(this.config.loginSendResetCode, body);
    };
    AuthenticationService.prototype.forgotPassword = function (phone) {
        this.loaderService.show();
        var body = {};
        if (phone) {
            body.phone = phone;
        }
        //console.log('forgotPassword', body);
        return this.http.post(this.config.forgotPassword, body);
    };
    AuthenticationService.prototype.logoutRequest = function () {
        return this.http.post(this.config.logout, {});
    };
    AuthenticationService.prototype.setUserLogged = function (info, phone) {
        this.setCurrentUserPhone(phone);
        this.setData(info);
        this.userLoggedIn.emit(true);
        this.activeLoginBtnText = this.btnLoginText.logout;
    };
    AuthenticationService.prototype.setData = function (result) {
        // this.storage = sessionStorage;
        this.storage.setItem('currentUser', JSON.stringify(result));
    };
    AuthenticationService.prototype.logout = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (this.storage.getItem('currentUser')) {
                    this.logoutRequest().toPromise();
                }
                this.storage.removeItem('currentUser');
                //this.storage.clear();
                this.userLoggedIn.emit(false);
                this.activeLoginBtnText = this.btnLoginText.login;
                document.querySelectorAll('.investments-popup').forEach(function (popup) {
                    popup.classList.remove('is-active');
                });
                this.popupComponent.closePopup();
                return [2 /*return*/];
            });
        });
    };
    AuthenticationService.prototype.refreshTokenNow = function () {
        var _this = this;
        if (this.storage.getItem('currentUser')) {
            this.http.post(this.config.refresh, {}).subscribe(function (res) {
                if (res.status) {
                    _this.setData(res.result);
                }
                else {
                    _this.mainTabsService.resetActiveTab();
                    _this.navigationService.goToHomePage();
                }
                return res;
            });
        }
        return false;
    };
    AuthenticationService.prototype.refreshToken = function () {
        var $this = this;
        setTimeout(function () {
            $this.refreshToken();
        }, 60 * 5 * 1000);
        this.refreshTokenNow();
    };
    AuthenticationService.prototype.getCurrentUser = function () {
        if (this.storage.getItem('currentUser')) {
            try {
                var currentUser = JSON.parse(this.storage.getItem('currentUser'));
                return currentUser;
            }
            catch (e) {
            }
        }
        return false;
    };
    AuthenticationService.prototype.getCurrentUserFirstName = function () {
        if (this.storage.getItem('currentUser')) {
            try {
                var currentUser = JSON.parse(this.storage.getItem('currentUser'));
                return currentUser.first_name;
            }
            catch (e) {
            }
        }
        return false;
    };
    AuthenticationService.prototype.getCurrentUserLastName = function () {
        if (this.storage.getItem('currentUser')) {
            try {
                var currentUser = JSON.parse(this.storage.getItem('currentUser'));
                return currentUser.last_name;
            }
            catch (e) {
            }
        }
        return false;
    };
    AuthenticationService.prototype.getCurrentUserEmail = function () {
        if (this.storage.getItem('currentUser')) {
            try {
                var currentUser = JSON.parse(this.storage.getItem('currentUser'));
                return currentUser.email;
            }
            catch (e) {
            }
        }
        return false;
    };
    AuthenticationService.prototype.setCurrentUserPhone = function (phone) {
        this.storage.setItem('currentUserPhone', phone);
    };
    AuthenticationService.prototype.getCurrentUserPhone = function () {
        if (this.storage.getItem('currentUserPhone')) {
            try {
                return JSON.parse(this.storage.getItem('currentUserPhone'));
            }
            catch (e) {
            }
        }
        return false;
    };
    AuthenticationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthenticationService_Factory() { return new AuthenticationService(i0.ɵɵinject(i1.AuthConfig), i0.ɵɵinject(i2.HttpClient), i0.ɵɵinject(i3.NavigationService), i0.ɵɵinject(i4.MainTabsService), i0.ɵɵinject(i5.LoaderService), i0.ɵɵinject(i6.PopupComponent)); }, token: AuthenticationService, providedIn: "root" });
    return AuthenticationService;
}());
export { AuthenticationService };
